// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_LQ8ow","header":"header_norCW","secure":"secure_78NqV","icon":"icon_GVzo2","shopping":"shopping_DTtJU"};